<template>
  <div class="container-fluid text-center newsletter-form">
    <div class="row pt-4">
      <div class="col-12 p-3">
        <img src="../assets/images/icons/newsletter.svg" alt="">
      </div>
      <div class="col-12 pb-2 title-font">
        <h3>Subscribe and get Exclusive Deals</h3>
      </div>
    </div>
    <form class="needs-validation" id="NewsletterForm" method="post" @submit="saveRequest" novalidate>
      <!-- Honeypot: hidden from users, bots tend to fill it -->
      <div class="hp-field" aria-hidden="true">
        <label for="nf-website">Website</label>
        <input type="text" id="nf-website" name="website" tabindex="-1" autocomplete="off" v-model="form.honeypot">
      </div>
      <div class="row justify-content-center px-md-5 mx-md-5 pb-5 gy-3">
        <div class="col-lg-2">
          <input type="text" class="form-control" id="validationCustom01" placeholder="First Name"
            v-model="form.firstName" required>
          <div class="invalid-feedback">
            Please provide your first name
          </div>
        </div>
        <div class="col-lg-2">
          <input type="text" class="form-control" id="validationCustom01" placeholder="Last Name"
            v-model="form.lastName" required>
          <div class="invalid-feedback">
            Please provide your Last Name
          </div>
        </div>
        <div class="col-lg-2">
          <input type="email" class="form-control" id="validationCustom01" placeholder="Email" v-model="form.email"
            required>
          <div class="invalid-feedback">
            Please provide your Email
          </div>
        </div>
        <div class="col-lg-2">
          <input type="text" class="form-control" id="validationCustom01" placeholder="Phone Number"
            v-model="form.phone" maxlength="10" minlength="10" pattern="^\d{10}$" required>
          <div class="invalid-feedback">
            provide a valid Phone Number
          </div>
          <div class="row d-grid text-start">
            <div class="col">
              <div class="form-check mb-3 ms-2 m-2">
                <input type="checkbox" class="form-check-input agreement" id="agreementCheck"  v-model="form.agreement" required>
               
                <label class="form-check-label agreement pt-1" for="agreementCheck">
                  I have read the 
                  <router-link target="_blank" class="text-aqua text-decoration-underline" to='/privacy-policy#sms-opt-out'>privacy policy</router-link> 
                  and agree to subscirbe and recieve messages from Amazing Mexico
                </label>
                <div class="invalid-feedback agreement">Please agree to receive SMS messages</div>
              </div>
            </div>
          </div>
          <!-- <div class="col">
            <div class="form-check mb-3">
              <input type="checkbox" class="form-check-input" id="validationFormCheck1" required>
              <label class="form-check-label" for="validationFormCheck1">Check this checkbox</label>
              <div class="invalid-feedback">Example invalid feedback text</div>
            </div>
            I Agree to receive SMS messages
            from Amazing Mexico
          </div> -->
        </div>
        <div class="col-lg-1 ps-4  pe-4 pe-lg-0 text-start">
          <div class="row"><button class="submit-btn p-2 px-4 h-100" type="submit">Submit</button></div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
// Public site key; falls back to the literal value if .env wasn't loaded at build time
const RECAPTCHA_SITE_KEY = process.env.VUE_APP_RECAPTCHA_SITE_KEY || "6LfmKM0tAAAAAKhYaLq-xDGE6fiL00iBFjDlPAnR";
export default {
  data() {
    return {
      form: this.initialValues()
    }
  },
  methods: {
    initialValues() {
      return {
        webhookID: "4a55394f-2b41-1618-5bf1-2c778e0df79b",
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        leadTypeID: 99,
        agreement: false,
        honeypot: "",
        recaptchaToken: null,
        leadSourceChannelID: localStorage.getItem('utm_medium'),
        leadSourceID: localStorage.getItem('utm_source'),
        campaignName: localStorage.getItem('utm_campaign'),
      };
    },
    saveRequest(e) {
      let form = e.target;
      if (this.form.honeypot) {
        // Bot detected: pretend success without sending the lead
        e.preventDefault();
        this.successMessage();
        this.resetValues();
        return;
      }
      if (form.checkValidity() === true) {
        this.waiting = true;
        this.loadingMessage()
        var url =
          "https://hooks.zapier.com/hooks/catch/4763102/4mooc65/";
        this.getRecaptchaToken()
          .then((token) => {
            this.form.recaptchaToken = token;
            return fetch(url, {
              method: "POST",
              body: JSON.stringify(this.form),
              // headers: {
              //   "Content-Type": "application/json",
              // },
            });
          })
          .then(() => {
            this.successMessage();
            this.triggerGTM();
            this.resetValues();
            window.gtag_report_conversion_qr();
          })
          .catch(() => {
            this.waiting = false;
            this.errorMessage()
          });
      }
      form.classList.add("was-validated");
      e.preventDefault();
    },
    loadRecaptcha() {
      if (document.getElementById("recaptcha-v3-script")) return;
      const script = document.createElement("script");
      script.id = "recaptcha-v3-script";
      script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    },
    getRecaptchaToken() {
      // Tokens expire after 2 minutes, so request one on each submit
      return new Promise((resolve, reject) => {
        if (!window.grecaptcha) return reject(new Error("reCAPTCHA not loaded"));
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(RECAPTCHA_SITE_KEY, { action: "newsletter" })
            .then(resolve, reject);
        });
      });
    },
    triggerGTM() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'form_success', 'formname': 'suscribe_deals', 'corporate': 'tafer' });
    },
    loadingMessage() {
      this.loading = Swal.mixin({
        customClass: {
          loader: 'spinner',
        }
      })
      return this.loading.fire({
        text: "Submitting",
        showConfirmButton: false,
        iconColor: "##0B6482",
        backdrop: `rgba(0,0,0,0.5)`,
        width: 160,
        timerProgressBar: true,
        // timer: 3000,
        didOpen: () => {
          this.loading.showLoading();
        },
      });
    },
    successMessage() {
      this.tab = 3
      return Swal.fire({
        icon: "success",
        title: "Thanks, all set.",
        text: "An agent will be in touch with you soon.",
        color: "#0B6482",
        showConfirmButton: false,
        timer: 5000,
        iconColor: "#0B6482",
        backdrop: `rgba(0,0,0,0.5)`,
        customClass: {
          title: 'sweetAlerTitle',
          icon: 'successIcon',
        }
      });
    },
    errorMessage() {
      return Swal.fire({
        icon: "warning",
        title: "Oops",
        text: "An unexpected error ocurred, please try again.",
        color: "#0B6482",
        iconColor: "#ffd700",
        showConfirmButton: false,
        // timer: 5000,
        backdrop: `rgba(0,0,0,0.5)`,
      });
    },
    // validEmail(email) {
    //   var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //   return re.test(email);
    // },
    resetValues() {
      this.form = this.initialValues();
      document.getElementById("NewsletterForm").classList.remove("was-validated");
    },
  },
  mounted() {
    this.loadRecaptcha();
  },
}
</script>

<style>
.newsletter-form {
  background-color: #0094A1;
}

.hp-field {
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.submit-btn {
  border-radius: 4px;
  background: #AED351;
  color: #FFF;
  text-align: center;
  font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: #ffff;
  border: 0;
}

.title-font {
  font-family: "oh_golds_demoregular";
  color: #ffff;
}

.sweetAlerTitle {
  font-weight: 900;
  font-size: 36px;
  font-family: Montserrat;
}

.successIcon {
  /* border-width: 9px!important; */
  line-height: normal;
}

.form-check-label.agreement {
  color: #FFF;
  font-size: 12px;
}

.form-check-input:checked {
  background-color: #aed351 !important;
  color: #0094A1 !important;
}

.invalid-feedback.agreement {
  font-size: 12px;
}

.was-validated .form-check-input:valid~.form-check-label,
.form-check-input.is-valid~.form-check-label.agreement {
  color: #ffff !important;
}

/* .swal2-success-ring {
    border-width: 9px!important;
}
.swal2-success-line-tip {
    border-width: 9px!important;
}
.swal2-success-line-long{
    border-width: 9px!important;
} */
</style>